import { useFiboActions } from "../useFiboActions/useFiboActions";
import { useFiboFileUpload } from "../useFiboFileUpload/useFiboFileUpload";

type UseFiboConfigProps = {
	activeTab: "generate" | "refine";
	isRefineTabEnabled: boolean;
};

export const useFiboConfig = ({ activeTab, isRefineTabEnabled }: UseFiboConfigProps) => {
	const actions = useFiboActions({ activeTab, isRefineTabEnabled });
	const fileUpload = useFiboFileUpload({ activeTab });

	return {
		...actions,
		...fileUpload,
	};
};
